module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 026.76a39546.jpg";